// extracted by mini-css-extract-plugin
module.exports = {"container":"ClearButton_container__2I1Ws"};